import { render } from "./corpProjectDetail.vue?vue&type=template&id=1fafdcc4&scoped=true"
import script from "./corpProjectDetail.vue?vue&type=script&lang=js"
export * from "./corpProjectDetail.vue?vue&type=script&lang=js"

import "./corpProjectDetail.vue?vue&type=style&index=0&id=1fafdcc4&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fafdcc4"]])

export default __exports__